import _ from 'lodash';
import { createSelector } from 'reselect';

import BuilderSlx  from 'app/selectors/company-admin/builder-dashboard';
import EntitiesSlx from 'app/selectors/entities';

const selCompanyDashboardId = state => state.companyAdmin.pageDashboardEdit.companyDashboardId;
const selLoadPending = state => state.companyAdmin.pageDashboardEdit.loadPending;

const selDashboard = createSelector(
  [selCompanyDashboardId, EntitiesSlx.companyDashboards, BuilderSlx.saveAttrs],
  (id, dashboards, saveAttrs) => {
    const dashboard = dashboards[id];
    // merging with saveAttrs enables the live preview magic
    return {...dashboard, ...saveAttrs};
  }
);

const selDashboardData = createSelector(
  [selCompanyDashboardId, EntitiesSlx.companyDashboardDatas],
  (id, dashboardDatas) => dashboardDatas[id]
);

const selCompany = createSelector(
  [selDashboard, EntitiesSlx.companies],
  (dashboard, companies) => dashboard && companies[dashboard.companyId]
);

export default {
  loadPending: selLoadPending,
  dashboard: selDashboard,
  dashboardData: selDashboardData,
  company: selCompany,
};
